/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessParty } from '../../models/business-party';

export interface ByBpGuid$Params {
  bpGuid: string;
  searchMethod?: 'MANUAL' | 'ELECTRONIC' | 'EMDIS' | 'UNKNOWN';
}

export function byBpGuid(http: HttpClient, rootUrl: string, params: ByBpGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<BusinessParty>> {
  const rb = new RequestBuilder(rootUrl, byBpGuid.PATH, 'get');
  if (params) {
    rb.path('bpGuid', params.bpGuid, {});
    rb.query('searchMethod', params.searchMethod, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BusinessParty>;
    })
  );
}

byBpGuid.PATH = '/business-parties/{bpGuid}';
